import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './MyLists.css';
import axios from 'axios';

function MyLists() {
    // State to hold the list of questions
    const [myQuestions, setMyQuestions] = useState([]);
    const navigate = useNavigate();

    const handleQuestionClick = (question) => {
        navigate(`/practice-question/${question.id}`, {
            state: {
                questionNumber: question, // question number
                questionTitle: question.title // question title
            }
        });
    };

    const handleRemoveQuestion = async (questionId) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/add_to_list`,
                { question_id: questionId, action: 'remove' },
                { withCredentials: true }
            );

            // If the response is ok, remove the question from the state to update the UI
            setMyQuestions(prevQuestions => prevQuestions.filter(q => q.id !== questionId));
        } catch (error) {
            console.error('Error removing question:', error);
        }
    };

    useEffect(() => {
        const fetchMyQuestions = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/get_user_list`, {
                    withCredentials: true
                });

                // Directly access the data property; no need to check response.ok
                setMyQuestions(response.data.questions);
            } catch (error) {
                console.error('Error fetching questions:', error);
            }
        };

        fetchMyQuestions();
    }, []);


    return (
        <div className="my-lists-container">
            <table className="my-questions-table">
                <thead>
                    <tr>
                        <th colSpan="3" className="my-lists-title">My Lists</th> {/* Updated colSpan */}
                    </tr>
                </thead>
                <tbody>
                    {myQuestions.map((question, index) => (
                        <tr key={index}>
                            <td className="checkmark-cell">
                                {question.hasSubmitted && <span className="checkmark">✔️</span>}
                            </td>
                            <td
                                className="question-title-cell"
                                onClick={() => handleQuestionClick(question)}
                                style={{ cursor: 'pointer' }}
                            >
                                {question.id}. {question.title}
                            </td>
                            <td className="delete-icon-cell">
                                <button onClick={() => handleRemoveQuestion(question.id)} className="delete-button">
                                    <img src="./delete_icon.png" alt="Delete" className="delete-icon" />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default MyLists;
